// KiCad projects --- what a board is, as KiCad read it from its project (layers, thickness, size, copper, finish,
// colours, the smallest track, gap and hole, the layer order), shown above the spec's text as a table nobody edits
// (Mitch, 2026-11-04: "an organized, nice table that is non-user modifiable because it's tied to the data"). It comes
// from the Gerbers zip KiCad made (file_version.board, migration 079) and changes when a newer project is uploaded.
import { useMemo } from "react";
import type { Spec } from "../../../../shared/db.gen.ts";
import { boardFactsOf, boardMarkdown } from "../../../../shared/kicad.ts";
import { renderMarkdown } from "../../../../shared/markdown.ts";
import { useRows } from "../../lib/sync.ts";

export function BoardFacts({ spec, lang = "en" }: { spec: Spec; lang?: "en" | "zh" }) {
  const slots = useRows("spec_file");
  const versions = useRows("file_version");
  const html = useMemo(() => {
    const current = new Set(slots.filter((f) => f.spec_id === spec.id && f.current_version_id).map((f) => f.current_version_id));
    return versions
      .filter((v) => current.has(v.id))
      .flatMap((v) => ((b) => (b ? [renderMarkdown(boardMarkdown(b.board, b, lang, b.layers))] : []))(boardFactsOf(v.board)));
  }, [slots, versions, spec.id, lang]);
  if (!html.length) return null;
  return (
    <div className="mb-2 rounded-md border border-line bg-surface-2/40 px-3 py-2">
      <div className="mb-1 text-[11px] font-medium tracking-wide text-faint uppercase">From the KiCad project · not editable</div>
      {html.map((h) => (
        // biome-ignore lint/security/noDangerouslySetInnerHtml: renderMarkdown escapes everything it's given (shared/markdown.ts)
        <div key={h} className="md text-[13px]" dangerouslySetInnerHTML={{ __html: h }} />
      ))}
    </div>
  );
}
